import type { DeepPartial } from '@luna/utils-ts';

import type { OverviewFeatureConfig } from './type';

export const overview: DeepPartial<OverviewFeatureConfig> = {
    products: {
        currentAccount: {
            secondaryAmount: 'sk-ownResources',
        },
    },
};
